<script setup>
const themes = [
  {
    name: 'dark',
    icon: 'tabler-moon',
  },
  {
    name: 'light',
    icon: 'tabler-sun-high',
  },
]
</script>

<template>
  <ThemeSwitcher :themes="themes" />
</template>
